import styled from 'styled-components';

export const SpinnerContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
`;

export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const Message = styled.h3<{ $whiteText?: boolean }>`
  margin: 8px auto;
  color: ${(props) => (props.$whiteText ? 'white' : 'default')};
`;
